const makeEven = (number) => (number % 2 === 0 ? number : number - 1);

export default makeEven;
